import '../../components/DataTableV2Rows.css';
import '../../DataTableV2.css';
import '../../components/Alignment.css';
import '../ColumnOrder/ColumnOrder.css';
import '../Thresholds/Thresholds.css';
import '../../components/DataTableV2Header.css';
import './DataTableV2GanttChartHeader.css';
export var ganttChartHeaderCSS = '_12efhbt0-2-0-1';